import React, { createContext, useContext, useEffect, useState } from "react";
import { deleteAllCookies, getCookie, setCookie } from "../Helpers/Utils";
import Handler from "../Helpers/Components/Handler";

const AuthContext = createContext();

function AuthenticateProvider({ children }) {
  const [userDetails, setUserDetails] = useState({})
  const person = getCookie("person")
  const token = getCookie("token")
  const [request, setRequest] = useState(false)
  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const [unauthorized, setUnauthorized] = useState(false);
  useEffect(() => {
    const handleUnauthorized = () => {
      deleteAllCookies();
      setIsAuthenticated(false);
      setUnauthorized(true);
    };
    window.addEventListener("app:unauthorized", handleUnauthorized);
    return () => window.removeEventListener("app:unauthorized", handleUnauthorized);
  }, []);
  const logIn = (token, person) => {
    if (token) {
      localStorage.removeItem('filter')
      setCookie("token", token);
      setCookie("person", person);
      setIsAuthenticated(true);
    }
  };
  const getRequestList = async () => {
    const response = await Handler({ url: `/${person === "admin" ? "admin" : "subadmin"}/request/check`, method: 'GET' })
    if (response.success) {
      setRequest(true)
    } else {
      setRequest(false)
    }
  }
  const logOut = async () => {
    const token = getCookie("token");
    if (!token) return;
    try {
      await Handler({ method: "POST", url: `/${person === "admin" ? "admin" : "subadmin"}/logout`, });
    } catch (e) { }
    deleteAllCookies();
    localStorage.clear();
    sessionStorage.clear();
    setIsAuthenticated(false);
    window.location.replace("/login");
  };
  const getDetails = async () => {
    const person = getCookie('person')
    if (person && isAuthenticated) {
      const value = await Handler({ method: "get", url: `/${person === 'admin' ? "admin" : "subadmin"}/view` });
      if (value?.success) {
        setUserDetails(value?.data)
      }
    }
  }
  useEffect(() => {
    if (token) {
      getDetails()
      setIsAuthenticated(true);
      getRequestList()
    }
  }, [token]);
  return (
    <AuthContext.Provider value={{ logIn, logOut, isAuthenticated, userDetails, setIsAuthenticated, getDetails, request, unauthorized, setUnauthorized }}>
      {children}
    </AuthContext.Provider>
  );
}

export default AuthenticateProvider;

export const useAuth = () => {
  return useContext(AuthContext);
};